import React, { useState, useEffect } from 'react';
import {
  FaTimes, FaUser, FaSignOutAlt, FaCalendarCheck,
  FaClipboardList, FaTasks, FaProjectDiagram, FaUserShield,FaFileAlt, FaUserFriends, FaMapMarkerAlt, FaMapMarkedAlt, FaTachometerAlt, FaMicrophoneAlt
} from 'react-icons/fa';
import { NavLink, useNavigate } from 'react-router-dom';


const Sidebar = ({ isOpen, onClose }) => {
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
  const navigate = useNavigate();

  const navLinkClass = ({ isActive }) =>
    `flex items-center space-x-3 px-4 py-3 rounded-md transition-all duration-200 ${
      isActive
        ? 'bg-gradient-to-r from-pink-200 to-purple-200 text-purple-900 font-semibold shadow-md'
        : 'text-gray-700 hover:bg-purple-100 hover:text-purple-700'
    }`;

  const handleLogout = () => {
    localStorage.removeItem('admin');
    setShowLogoutConfirm(false);
    navigate('/');
  };

  // Prevent body scroll when sidebar is open
  useEffect(() => {
    document.body.style.overflow = isOpen ? 'hidden' : 'auto';
  }, [isOpen]);

  return (
    <>
      {/* Background overlay */}
      {isOpen && (
        <div
            onClick={onClose}
            className="fixed inset-0 bg-black bg-opacity-10 z-[9998]"
        />
        )}

      {/* Sidebar */}
      <div
        className={`fixed top-0 left-0 h-full w-64 bg-gradient-to-b from-white via-purple-50 to-pink-50 shadow-2xl transform transition-transform duration-300 z-[9999] ${
          isOpen ? 'translate-x-0' : '-translate-x-full'
        } overflow-y-auto`}
      >
        {/* Header */}
        <div className="flex justify-between items-center px-5 py-4 border-b border-purple-100 shadow-sm">
          <h2 className="text-2xl font-bold text-purple-700 font-mono">Dashboard</h2>
          <FaTimes className="cursor-pointer text-gray-500 hover:text-red-500 text-xl" onClick={onClose} />
        </div>

        {/* Menu */}
        <ul className="p-4 space-y-2 text-base font-medium">
          <li><NavLink to="/overview" className={navLinkClass}><FaTachometerAlt /><span>Overview</span></NavLink></li>
         <li>
           <a
             href="https://uniquefin.lifechangers.space/"
             target="_blank"
             rel="noopener noreferrer"
             style={{
               display: "flex",
               alignItems: "center",
               gap: "10px",
               padding: "10px 15px",
               borderRadius: "8px",
               textDecoration: "none",
               color: "#333",
               fontWeight: "500",
               transition: "all 0.3s ease"
             }}
             onMouseEnter={(e) => {
               e.currentTarget.style.background = "linear-gradient(135deg, #ffb6c1, #ff69b4)";
               e.currentTarget.style.color = "#fff";
               e.currentTarget.style.transform = "translateX(5px)";
             }}
             onMouseLeave={(e) => {
               e.currentTarget.style.background = "transparent";
               e.currentTarget.style.color = "#333";
               e.currentTarget.style.transform = "translateX(0)";
             }}
           >
             <FaMicrophoneAlt />
             <span>Meeting Room</span>
           </a>
         </li>
          {/* <li><NavLink to="/admin-report" className={navLinkClass}><FaFileAlt/><span>Marketing Reports</span></NavLink></li> */}
          {/* <li><NavLink to="/marketing-livelocation" className={navLinkClass}><FaMapMarkedAlt /><span>Marketing Live Location</span></NavLink></li> */}
          
          <li><NavLink to="/admin/assigned-locations" className={navLinkClass}><FaMapMarkerAlt /><span>View Marketing Task</span></NavLink></li>
            <li><NavLink to="/marketing-members-ad" className={navLinkClass}><FaClipboardList /><span>View Marketing Reports</span></NavLink></li>
          <li><NavLink to="/attendance" className={navLinkClass}><FaCalendarCheck /><span>Attendance</span></NavLink></li>
          <li><NavLink to="/leave-report" className={navLinkClass}><FaClipboardList /><span>Leave Report</span></NavLink></li>
          <li><NavLink to="/tasks" className={navLinkClass}><FaTasks /><span>Team Task Management</span></NavLink></li>
          <li><NavLink to="/projects" className={navLinkClass}><FaProjectDiagram /><span>Team Project Tracking</span></NavLink></li>
          <li><NavLink to="/live-location" className={navLinkClass}><FaMapMarkedAlt /><span>Team Live Track</span></NavLink></li>
          <li><NavLink to="/add-workers" className={navLinkClass}><FaUserFriends /><span>Add Workers</span></NavLink></li>
          <li><NavLink to="/location" className={navLinkClass}><FaMapMarkerAlt /><span>Add Location</span></NavLink></li>
           {/* <li><NavLink to="/admin-voice" className={navLinkClass}><FaMicrophoneAlt /><span>Voice Chat</span></NavLink></li> */}
          {/* <li><NavLink to="/admin-access" className={navLinkClass}><FaUserShield /><span>Admin Access</span></NavLink></li> */}
          <li><NavLink to="/admin-profile" className={navLinkClass}><FaUser /><span>Profile</span></NavLink></li>

          {/* Logout */}
          <li className="pt-4 border-t border-purple-200">
            <button
              onClick={() => setShowLogoutConfirm(true)}
              className="flex items-center space-x-3 px-4 py-3 rounded-md text-red-600 hover:bg-red-100 hover:text-red-700 transition-all duration-200 w-full"
            >
              <FaSignOutAlt className="text-lg" />
              <span>Logout</span>
            </button>
          </li>
        </ul>
      </div>

      {/* Logout Modal */}
      {showLogoutConfirm && (
        <div className="fixed inset-0 bg-black bg-opacity-40 backdrop-blur-sm z-50 flex items-center justify-center">
          <div className="bg-white rounded-lg shadow-lg p-6 w-80 text-center">
            <h2 className="text-xl font-bold text-gray-800 mb-4">Are you sure you want to logout?</h2>
            <div className="flex justify-center space-x-4">
              <button
                onClick={handleLogout}
                className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600"
              >
                Yes
              </button>
              <button
                onClick={() => setShowLogoutConfirm(false)}
                className="px-4 py-2 bg-gray-300 text-gray-700 rounded hover:bg-gray-400"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Sidebar;
